import axios from "../helpers/axios";
import { setApplication } from "../reducers/application.reducer";
import { deletedApplication } from "./api/application";
import { applicationConstants } from "./constants";



export const deleteManyApplication = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: applicationConstants.DELETE_MANY_REQUEST });
      const res = await axios.post("/application/deleteMany", payload);
      if (res.status === 200) {
        dispatch({
          type: applicationConstants.DELETE_MANY_SUCCESS,
          payload: res.data
        });
        dispatch(getApplication())
      } else {
        dispatch({
          type: applicationConstants.DELETE_MANY_FAILURE,
          payload: res.status
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};


export const getApplication = (sort) => {
  return async (dispatch) => {
    try {
      dispatch({ type: applicationConstants.GET_ALL_APPLICATION_REQUEST });
      let url = "application/getApplications"
      if (sort) {
        url = `application/getApplications?sort=${sort}`
      }
      const res = await axios.get(url);
      if (res.status === 200) {
        const { applications } = res.data;
        dispatch({
          type: applicationConstants.GET_ALL_APPLICATION_SUCCESS,
          payload: { applications },
        });
      } else {
        dispatch({ type: applicationConstants.GET_ALL_APPLICATION_FAILURE });
      }
    } catch (error) {
      console.log(error);
    }
  };
};
export const updateApplicationStatus = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: applicationConstants.UPDATE_STATUS_REQUEST });
      const res = await axios.post("/application/updateStatus", payload);
      if (res.status === 201) {
        dispatch({
          type: applicationConstants.UPDATE_STATUS_SUCCESS,
          payload: res.data
        });
      } else {
        dispatch({
          type: applicationConstants.UPDATE_STATUS_FAILURE,
          payload: res.status
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const searchApplication = (search) => {
  return async dispatch => {
    try {
      const response = await axios.get(`/application/getApplications/search?search=${search}`)
      dispatch(setApplication(response.data))
    } catch (e) {
      alert(e?.response?.data?.message)
    }
  }
}

export const deleteApplicationById = (id) => async (dispatch) => {
  try {
    await deletedApplication(id);
    dispatch({ type: applicationConstants.DELETE_APPLICATION_BY_ID_SUCCESS, payload: id });
    dispatch(getApplication())
  } catch (error) {
    console.log(error);
  }
} 